<template>
  <div :class="['flex flex-row top', $style.criteriaContainer]">
    <div
      v-if="selectedCriteria.length === 1"
      class="flex flex-row top width-100 padding-8"
    >
      <div :class="$style.itemBox">
        <div :class="['flex flex-row top', $style.criteriaDetailBox]">
          <p :class="$style.documentId">
            {{ selectedCriteria[0].documentId }}
          </p>
          <p :class="$style.title">{{ selectedCriteria[0].title }}</p>
        </div>
      </div>
    </div>
    <div v-if="selectedCriteria.length > 1" class="flex flex-row top width-100">
      <b-collapse v-model="isOpen" class="grip-criteria-dropdown-list-collapse">
        <div v-if="!isOpen" class="grip-collapse-container-btn">
          <div :aria-expanded="isOpen" class="flex flex-row top width-100">
            <div :class="[$style.itemBox, 'width-100']">
              <div :class="['flex flex-row top', $style.criteriaDetailBox]">
                <p :class="$style.documentId">
                  {{ selectedCriteria[0].documentId }}
                </p>
                <p :class="$style.title">
                  {{ selectedCriteria[0].title }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div v-if="isOpen" :class="$style.criteriaList">
          <div
            v-for="(criteria, index) in selectedCriteria"
            :key="index"
            :class="$style.itemBox"
          >
            <div :class="['flex flex-row top', $style.criteriaDetailBox]">
              <p :class="$style.documentId">{{ criteria.documentId }}</p>
              <p :class="$style.title">
                {{ criteria.title }}
              </p>
            </div>
          </div>
        </div>
      </b-collapse>
      <div class="flex flex-row top" @click="handledOpen">
        <p v-if="!isOpen" :class="$style.moreCriteriaTag">
          {{ `+${selectedCriteria.length - 1} more criteria` }}
        </p>
        <b-button :class="$style.triggerBtn">
          <b-icon :icon="!isOpen ? 'chevron-down' : 'chevron-up'" />
        </b-button>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ProjectCriteria } from '../../../store/modules/projects/types/projects.types';

@Component({
  components: {},
})
export default class GripAnalysisCriteria extends Vue {
  @Prop() public selectedCriteria!: ProjectCriteria[];
  public isOpen: boolean = false;

  public handledOpen(): void {
    this.isOpen = !this.isOpen;
  }
}
</script>
<style lang="scss" module>
.criteriaContainer {
  padding: 8px 16px;
  width: 100%;
  left: 0px;
  top: 0px;
  border-bottom: 1px solid #dbdbdb;
}

.criteriaList {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0 8px;
  max-height: 100px;
  overflow: scroll;
  width: 100%;

  .itemBox {
    align-items: center;
    width: 100%;
    padding: 8px 0;
  }
}

.moreCriteriaTag {
  font-size: 10px;
  font-weight: 600;
  line-height: 14px;
  background: #e6ecf6;
  border-radius: 4px;
  color: #444f51;
  text-align: center;
  padding: 2px 4px;
  white-space: nowrap;
  margin: 0 16px;
  text-transform: lowercase;
  cursor: pointer;
}

.triggerBtn {
  background: none;
  border: none;
  padding: 10px 0px;
  margin-top: -10px;

  span {
    margin-left: unset;
    font-weight: 400;
    font-size: 14px;
    color: #444f51;
  }
  &:focus {
    box-shadow: none;
    border: none;
  }

  &:hover,
  &:active {
    border: none;
  }

  &:focus:not(:active),
  &.is-focused:not(:active) {
    box-shadow: none;
  }
}

.criteriaDetailBox {
  width: 100%;

  .title {
    width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    font-weight: 600;
    font-size: 14px;
    line-height: 19px;
    color: #444f51;
  }

  .documentId {
    font-weight: 400;
    font-size: 14px;
    line-height: 19px;
    margin-right: 10px;
    color: #9f9f9f;
    width: 14ch;
    white-space: nowrap;
  }
}
</style>
